module.exports = __webpack_public_path__ + "static/media/sellorders.f6f887ca.svg";